import { ChevronLeft, ChevronRight } from 'lucide-react'
import * as React from 'react'
import { DayPicker } from 'react-day-picker'

import { cn } from '@/lib/ui/style-helpers'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({
  className,
  classNames,
  components,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      hideNavigation
      showOutsideDays={showOutsideDays}
      className={cn('p-2', className)}
      classNames={{
        caption: 'hidden',
        caption_label: 'hidden',
        nav: 'space-x-1 flex items-center',
        weekdays: 'flex mb-1.5',
        weekday: 'w-9 text-main-foreground-tertiary text-label-small font-normal',
        week: 'flex items-center justify-between w-full mt-0.5',
        day_button: 'size-8 p-0 text-label-small !font-normal',
        outside:
          'text-main-foreground-disabled bg-main-background-interactive-list-disabled pointer-events-none cursor-not-allowed',
        disabled:
          'text-main-foreground-disabled bg-main-background-interactive-list-disabled pointer-events-none cursor-not-allowed',
        ...classNames,
      }}
      components={{
        ...components,
        Chevron: ({ orientation, className: chevronClassName, ...chevronProps }) =>
          orientation === 'left' ? (
            <ChevronLeft className={cn('size-4', chevronClassName)} {...chevronProps} />
          ) : (
            <ChevronRight className={cn('size-4', chevronClassName)} {...chevronProps} />
          ),
      }}
      {...props}
    />
  )
}
Calendar.displayName = 'Calendar'

export { Calendar }
